export const convertParamToObject = (el: string) => {
  const arr = el.split(",")
  if(arr.length > 1){
    let first = null
    let second = null
    if(arr[0]){
      first = arr[0]
    }
    if(arr[1]){
      second = arr[1]
    }
    return [first, second]
  }else {
    return arr[0]
  }
}

export const convertObjectToParam = (str: string[]) => {
  let first = "null"
  let second = "null"
  if(str[0]){
    first = str[0]
  }
  if(str[1]){
    second = str[1]
  }

  return `${first},${second}`
}
